var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.92885 19.6192V11.3208H0V7.88285H2.92885V5.27477C2.92885 2.31105 4.68617 0.651367 7.38071 0.651367C8.66941 0.651367 9.9581 0.888465 9.9581 0.888465V3.85219H8.4351C7.02925 3.85219 6.56063 4.80058 6.56063 5.74897V8.0014H9.84095L9.37233 11.3208H6.67779V19.6192",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.124d8de9e2927daeb8c05b0f0075d049.svg";
export { ForwardRef as ReactComponent };